import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import Backend from 'i18next-locize-backend'
import { initReactI18next } from 'react-i18next'

import careersEn from './assets/i18n/en/careers.json'
import careersFr from './assets/i18n/fr/careers.json'

import commonEn from './assets/i18n/en/common.json'
import commonFr from './assets/i18n/fr/common.json'

import reactivationEn from './assets/i18n/en/reactivation.json'
import reactivationFr from './assets/i18n/fr/reactivation.json'

import campaignEn from './assets/i18n/en/campaign.json'
import campaignFr from './assets/i18n/fr/campaign.json'

const locizeOptions = {
  projectId: process.env.REACT_APP_LOCIZE_PROJECT_ID,
  apiKey: process.env.REACT_APP_LOCIZE_API_KEY,
  referenceLng: 'fr',
}

const isDevEnv = process.env.NODE_ENV === 'development'

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: (navigator?.language || 'en').substring(0, 2),
    fallbackLng: 'en',
    fallbackNS: false,
    supportedLngs: ['fr', 'en'],
    wait: true,
    debug: false,
    backend: isDevEnv ? locizeOptions : {},
    saveMissing: true,
    ...(isDevEnv ? {} : { resources: {} }),
  })

if (!isDevEnv) {
  i18n.addResourceBundle('fr', 'careers', careersFr)
  i18n.addResourceBundle('fr', 'common', commonFr)
  i18n.addResourceBundle('fr', 'reactivation', reactivationFr)
  i18n.addResourceBundle('fr', 'campaign', campaignFr)

  i18n.addResourceBundle('en', 'careers', careersEn)
  i18n.addResourceBundle('en', 'common', commonEn)
  i18n.addResourceBundle('en', 'reactivation', reactivationEn)
  i18n.addResourceBundle('en', 'campaign', campaignEn)
}
if (window.Cypress) {
  window.i18n = i18n
}
export default i18n
